import { Component, Input, ElementRef, HostListener, HostBinding, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'bb-tooltip',
	templateUrl: './bb-tooltip.component.html',
	styleUrls: ['./bb-tooltip.component.scss']
})

export class BbTooltipComponent implements OnInit, OnDestroy {
	@Input() contents: string;
	@Input() link: string;
	@Input() targetElement: ElementRef;
	@Input() changeDetector: ChangeDetectorRef;
	@HostBinding('class.visible') visible = false;

	hovering = false;
	positioned = false;
	positionX: string;
	positionY: string;
	hideTimeoutId: any;

	constructor(private element: ElementRef) { }

	@HostListener('window:resize')
	onWindowResize(): void {
		this.positionElement();
	}

	ngOnInit() { }
	ngOnDestroy() {
		this.changeDetector = null;
	}


	show() {
		this.visible = true;

		if (this.hideTimeoutId) {
			clearTimeout(this.hideTimeoutId);
		}

		setTimeout(() => {
			this.positionElement();
		});
	}

	hide() {
		this.visible = false;
		if (this.changeDetector) {
			this.changeDetector.detectChanges();
		}
	}

	hideIfNotHovering() {
		if (!this.hovering) {
			this.hide();
		}
	}

	hoverIn() {
		this.hovering = true;
	}

	hoverOut() {
		this.hovering = false;

		this.hideTimeoutId = setTimeout(() => {
			this.hideIfNotHovering();
		}, 200);
	}

	positionElement() {

		const targetRect = this.targetElement.nativeElement.getBoundingClientRect();
		const elementRect = this.element.nativeElement.getBoundingClientRect();
		const windowRect = document.body.getBoundingClientRect();

		if (targetRect.left + elementRect.width > windowRect.width) {
			this.positionX = 'left';
			// +20 for positioning triangle
			this.element.nativeElement.style.left = (targetRect.left - elementRect.width + 20).toString() + 'px';
		} else {
			this.positionX = 'right';
			// - 10 for positioning triangle
			this.element.nativeElement.style.left = (targetRect.left - 10).toString() + 'px';
		}

		if (targetRect.top + elementRect.height > windowRect.height) {
			this.positionY = 'top';
			this.element.nativeElement.style.top = (targetRect.top - elementRect.height - targetRect.height - windowRect.top).toString() + 'px';

		} else {
			this.positionY = 'bottom';
			this.element.nativeElement.style.top = (targetRect.top + targetRect.height - windowRect.top).toString() + 'px';
		}

		this.positioned = true;
		if (this.changeDetector) {
			this.changeDetector.detectChanges();
		}
	}
}
